import React, { useState } from 'react';
import { Button, Select, Popover, Space } from '@arco-design/web-react';
import { IconFilter, IconRefresh } from '@arco-design/web-react/icon';

const RegionFilter = ({ onFilter, placeholder = '请选择地区' }) => {
  const [visible, setVisible] = useState(false);
  const [regionValue, setRegionValue] = useState('');
  const [hasFilter, setHasFilter] = useState(false);

  // 中国省份列表
  const provinces = [
    '北京', '天津', '上海', '重庆',
    '河北', '山西', '辽宁', '吉林', '黑龙江',
    '江苏', '浙江', '安徽', '福建', '江西', '山东',
    '河南', '湖北', '湖南', '广东', '海南',
    '四川', '贵州', '云南', '陕西', '甘肃', '青海',
    '台湾', '内蒙古', '广西', '西藏', '宁夏', '新疆',
    '香港', '澳门'
  ];

  const handleFilter = () => {
    onFilter(regionValue);
    setHasFilter(!!regionValue);
    setVisible(false);
  };

  const handleClear = () => {
    setRegionValue('');
    onFilter('');
    setHasFilter(false);
    setVisible(false);
  };

  const content = (
    <div style={{ width: 145, padding: '8px 0' }}>
      <Select
        placeholder={placeholder}
        value={regionValue}
        onChange={setRegionValue}
        style={{ marginBottom: 8, width: '100%' }}
        allowClear
        showSearch
        filterOption={(inputValue, option) =>
          option.children.toLowerCase().includes(inputValue.toLowerCase())
        }
      >
        {provinces.map(province => (
          <Select.Option key={province} value={province}>
            {province}
          </Select.Option>
        ))}
      </Select>
      <Space>
        <Button
          type="primary"
          size="small"
          onClick={handleFilter}
        >
          筛选
        </Button>
        <Button
          size="small"
          icon={<IconRefresh />}
          onClick={handleClear}
        >
          重置
        </Button>
      </Space>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      visible={visible}
      onVisibleChange={setVisible}
      position="bottom"
    >
      <Button
        size="small"
        icon={<IconFilter />}
        type={hasFilter ? 'primary' : 'secondary'}
        style={{
          color: hasFilter ? '#fff' : '#86909c'
        }}
      />
    </Popover>
  );
};

export default RegionFilter;